import styled, { css } from 'styled-components';
import { mq, getTransition, px2rem } from '../../../stylesheets/tools';

const StyledModalFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  z-index: 99;
  ${getTransition()}

  .modalFooter__logo {
    position: relative;
    cursor: pointer;
    padding: ${px2rem('25px')};

    ${mq('s')} {
      padding: ${px2rem('35px')};
    }
    ${mq('m')} {
      padding: ${px2rem('40px')} ${px2rem('45px')};
    }
    ${mq('xl')} {
      padding: ${px2rem('40px')} ${px2rem('55px')};
    }

    svg {
      height: 30px;
      width: 172px;
      fill: #fff;

      ${mq('m')} {
        width: auto;
        height: 35px;
      }

      ${props =>
        props.currentLevel > 2 &&
        css`
          fill: #fff;

          ${mq('m')} {
            fill: #000;
          }
        `}
    }

    ${mq('m')} {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
`;

export default StyledModalFooter;
